import React from 'react';
import { Provider } from 'react-redux';
import { store } from './store/store';
import './App.css';
import AppRouter from './AppRouter';
import { NotificationProvider } from './contexts/NotificationContext';

function App() {
  return (
    <Provider store={store}>
      <NotificationProvider>
        <AppRouter />
      </NotificationProvider>
    </Provider>
  );
}

export default App;
